import {
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
} from "@chakra-ui/react";
import { ReactElement } from "react";

interface IconButtonProps
  extends Omit<ChakraIconButtonProps, "onChange" | "aria-label"> {
  icon: ReactElement;
  onClick: () => void;
  variant: "primary" | "secondary" | "link" | "text";
  ariaLabel: string;
  isDisabled?: boolean;
}

export const IconButton = ({
  icon,
  onClick,
  variant,
  ariaLabel,
  isDisabled = false,
  fontSize = "xl",
  w = "40px",
  h = "40px",
  ...restProps
}: IconButtonProps) => {
  return (
    <ChakraIconButton
      {...restProps}
      w={w}
      h={h}
      aria-label={ariaLabel}
      variant={variant}
      onClick={onClick}
      icon={icon}
      isDisabled={isDisabled}
      isRound={true}
      fontSize={fontSize}
    />
  );
};
